
import * as React from "react"
import { format } from "date-fns"
import { Calendar as CalendarIcon } from "lucide-react"
import { cn } from "@/lib/utils"
import { Button } from "@/components/ui/button"
import { Calendar } from "@/components/ui/calendar"
import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from "@/components/ui/popover"

export interface DatePickerProps {
  date: Date | undefined
  onDateChange: (date: Date | undefined) => void
  label?: string
  className?: string
  modifiers?: {
    hasEntry?: Date[]
  }
}

export function DatePicker({ date, onDateChange, label, className, modifiers }: DatePickerProps) {
  return (
    <div className={className}>
      {label && (
        <div className="text-sm font-medium mb-1.5">{label}</div>
      )}
      <Popover>
        <PopoverTrigger asChild>
          <Button
            variant={"outline"}
            className={cn(
              "w-full justify-start text-left font-normal",
              !date && "text-muted-foreground"
            )}
          >
            <CalendarIcon className="mr-2 h-4 w-4" />
            {date ? format(date, "PPP") : <span>Pick a date</span>}
          </Button>
        </PopoverTrigger>
        <PopoverContent className="w-auto p-0" align="start">
          <Calendar
            mode="single"
            selected={date}
            onSelect={onDateChange}
            initialFocus
            className={cn("p-3 pointer-events-auto")}
            modifiers={{
              hasEntry: modifiers?.hasEntry || []
            }}
            modifiersStyles={{
              hasEntry: {
                fontWeight: 'bold',
                borderBottom: '2px solid var(--primary)',
              },
            }}
          />
        </PopoverContent>
      </Popover>
    </div>
  )
}
